import { Component, OnInit } from '@angular/core';
import { ContactRequestPdfTemplate } from '../contact-request-pdf-template';
import { HttpService } from '../service/http.service';
import { PdfDocumentTemplateService } from '../pdf-document-template.service';
import { PdfTemplateViewOption } from '../pdf-template-view-option.enum';
import { ToastMessageService } from '../toast-message.service';
import { ConfirmationService } from 'primeng/api';

@Component({
  selector: 'app-pdf-templates-lead-related',
  templateUrl: './pdf-templates-lead-related.component.html',
  styleUrls: ['./pdf-templates-lead-related.component.css']
})
export class PdfTemplatesLeadRelatedComponent implements OnInit {

  constructor(
    private httpService: HttpService,
    public pdfTemplateService: PdfDocumentTemplateService,
    private confirmationService: ConfirmationService,
    private toastService: ToastMessageService
  ) { }

  ngOnInit(): void {
    this.httpService.getContactRequestQuotationTemplatesByLanguage(this.pdfTemplateService.selectedLanguage).subscribe(res => {
      this.pdfTemplateService.contactRequestPdfTemplates = res;
    });
  }

  editSelectedContactRequestTemplate(template: ContactRequestPdfTemplate){
    this.pdfTemplateService.activeItemId = PdfTemplateViewOption.EDIT_CONTACT_REQUEST_RELATED;
    this.pdfTemplateService.selectedContactRequestPdfTemplate = template;
  }

  deleteTemplate(templateId: number){
    this.confirmationService.confirm({
      message: "Do you waint to delete the template id: " + templateId + "?",
      accept: () => {
        this.httpService.deleteContactRequestReportTemplate(templateId).subscribe(() => {
          this.removeTemplateFromArray(templateId);
          this.toastService.addSuccess("Success", "Template deleted");
        }, error => this.toastService.addError("Error", "Template could not be deleted"));
      }
    });
  }

  removeTemplateFromArray(templateId: number){
    const templates = this.pdfTemplateService.contactRequestPdfTemplates;
    for(let template of templates){
      if(template.id == templateId){
        const index = templates.indexOf(template);
        templates.splice(index, 1);
      }
    }
  }

}
